export const generateCloudflareImage = (image: string | undefined | null) =>
  `https://imagedelivery.net/5rSXXMZObak6gn7233hh2A/${image}/cart`;
